import React, { useEffect, useState } from 'react';
import AgConvergeHeroImage from '../images/SpurAgConverge2026.png';
import AgConvergeAgendaPDF from '../assets/AgConverge_2026_Agenda.pdf';
import CarouselImg from '../images/Carousel.jpg';
import Carousel1Img from '../images/Carousel1.jpg';
import Carousel4Img from '../images/Carousel4.jpg';
import Carousel5Img from '../images/Carousel5.jpg';
import Carousel6Img from '../images/Carousel6.jpg';


const REGISTRATION_URL = 'https://cvent.me/9E05M7';

const FTAC_STARTUP_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUQ0JJR0pIR01ZSlZIMzRXV0VPS0hJWEVaTy4u&route=shorturl';

const STUDENT_REGISTRATION_URL =
  'https://forms.cloud.microsoft/pages/responsepage.aspx?id=xAPQGhOJLkyxIGKu-ItszRXzT9VQp_xNskPnO7MBrzxUNURaN1haQUs2NEI3UlZBQkJOREtIOU05WS4u&route=shorturl';

const hotelOptions = [
  {
    name: 'Grand Island Casino Resort',
    label: 'At Fonner Park — Closest option',
    address: '777 E. Fonner Park Road, Grand Island, NE 68801',
    phone: '(308) 675-5600',
    description:
      'Located directly at Fonner Park, this is the closest lodging option to Raising Nebraska and the AgConverge venue. The resort includes hotel rooms, dining, entertainment, a pool, spa, and complimentary Wi-Fi.',
    url:
      'https://www.grandislandresort.com/hotel.html',
  },

  {
    name: 'Travelodge by Wyndham Grand Island',
    label: 'Adjacent to Fonner Park',
    address: '1311 S. Locust Street, Grand Island, NE 68801',
    phone: '(308) 594-0123',
    description:
      'A convenient budget-friendly hotel adjacent to Fonner Park and close to the Heartland Events Center. Amenities include free Wi-Fi, free parking, pet-friendly rooms, and airport shuttle service.',
    url:
      'https://www.wyndhamhotels.com/travelodge/grand-island-nebraska/grand-island-travelodge/overview',
  },

  {
    name: 'SureStay Plus Hotel by Best Western Grand Island',
    label: 'About 0.5 mile from Fonner Park',
    address: '2603 S. Locust Street, Grand Island, NE 68801',
    phone: '(308) 384-4380',
    description:
      'A nearby hotel on South Locust Street within easy reach of Fonner Park. Guests have access to complimentary breakfast, Wi-Fi, an indoor pool, fitness facilities, and free parking.',
    url:
      'https://www.bestwestern.com/en_US/book/hotel-rooms.54219.html',
  },

  {
    name: 'Island Inn',
    label: 'Near Fonner Park',
    address: '2311 S. Locust Street, Grand Island, NE 68801',
    phone: '(308) 382-1815',
    description:
      'A simple and affordable lodging option on South Locust Street close to the Fonner Park event area. Rooms include refrigerators, wireless internet, and free local calls.',
    url:
      'http://www.stayislandinn.com',
  },

  {
    name: 'Best Western Plus Grand Island Inn & Suites',
    label: 'About 1 mile from the event center',
    address: '2707 S. Locust Street, Grand Island, NE 68801',
    phone: '(308) 675-5656',
    description:
      'Located minutes from the Heartland Events Center, Fonner Park, and Nebraska State Fairgrounds. Amenities include a full hot breakfast, indoor heated pool, fitness center, Wi-Fi, and free parking.',
    url:
      'https://www.bestwestern.com/en_US/book/grand-island/hotel-rooms/best-western-plus-grand-island-inn-suites/propertyCode.28071.html',
  },

  {
    name: 'Ramada by Wyndham Midtown Grand Island',
    label: 'Near Fonner Park',
    address: '2503 S. Locust Street, Grand Island, NE 68801',
    phone: '(308) 384-1330',
    description:
      'A full-service hotel near the Heartland Events Center and Fonner Park with an indoor pool, on-site dining, conference facilities, breakfast, Wi-Fi, and parking.',
    url:
      'https://www.wyndhamhotels.com/ramada/grand-island-nebraska/ramada-midtown-grand-island/overview',
  },

  {
    name: 'MainStay Suites Grand Island',
    label: 'About 1 mile from Fonner Park',
    address: '3051 S. Locust Street, Grand Island, NE 68801',
    phone: '(308) 646-2091',
    description:
      'An extended-stay hotel near the Nebraska State Fairgrounds and Fonner Park with apartment-style suites, in-room kitchens, complimentary Wi-Fi, breakfast, and parking.',
    url:
      'https://www.choicehotels.com/nebraska/grand-island/mainstay-hotels/ne131',
  },
];

const sessionData = {
  day1: [
    {
      icon: 'fa-mug-hot',
      title: 'Registration & Coffee',
      desc: 'Exhibits and Startup Demonstration Stations open.',
      time: '8:00 – 9:00 AM',
      type: 'networking',
    },
    {
      icon: 'fa-microphone',
      title: 'Welcome & Framing the Two Days',
      time: '9:00 – 9:10 AM',
    },
    {
      icon: 'fa-bullhorn',
      title: 'Opening Address',
      desc: 'Ankit Chandra, Spur Ventures.',
      time: '9:10 – 9:25 AM',
    },
    {
      icon: 'fa-tractor',
      title: 'Producer Keynote',
      desc:
        'What Farms Need Now: A Producer’s View on AgTech Innovation.',
      time: '9:25 – 10:00 AM',
      badge: 'Keynote',
      type: 'featured',
    },
    {
      icon: 'fa-coffee',
      title: 'Networking Break',
      desc: 'Startup Demonstration Stations featured.',
      time: '10:00 – 10:30 AM',
      type: 'break',
    },
    {
      icon: 'fa-rocket',
      title: 'FTAC Phase 1: Startup Showcase',
      desc:
        'Eight Selected Startups: eight minutes pitch; your potential customers are in the room.',
      time: '10:30 – 11:45 AM',
      badge: 'FTAC Phase 1',
      type: 'featured',
    },
    {
      icon: 'fa-people-arrows',
      title: 'Transition to Lunch',
      desc: 'Transition from the morning program to lunch.',
      time: '11:45 AM – 12:00 PM',
      type: 'break',
    },
    {
      icon: 'fa-utensils',
      title: 'Lunch & Industry Keynote',
      desc:
        'Where Capital Is Going: Market Conditions and the Future of AgTech Investment. The keynote is scheduled from 12:20–12:45 PM.',
      time: '12:00 – 1:00 PM',
      badge: 'Lunch included',
      type: 'meal',
    },
    {
      icon: 'fa-table',
      title:
        'Track A: FTAC Phase 2 — Farmer Evaluation Roundtables',
      desc:
        'Farmers, founders, and facilitators participate in a closed evaluation session.',
      time: '1:00 – 2:15 PM',
      badge: 'Closed session',
      type: 'track',
    },
    {
      icon: 'fa-users',
      title: 'Track B: Industry–Academia Partnership Panel',
      desc:
        'From Research to Impact. The Industry–Academia Panel runs from 1:05–1:45 PM, followed by open demonstration time until 2:15 PM.',
      time: '1:00 – 2:15 PM',
      badge: 'Open session',
      type: 'track',
    },
    {
      icon: 'fa-robot',
      title: 'Afternoon Break',
      desc: 'Robotics & Technology Demonstration Arena featured.',
      time: '2:15 – 2:45 PM',
      type: 'break',
    },
    {
      icon: 'fa-award',
      title: 'FTAC Phase 3: Producer Verdict & Farm Awards',
      desc:
        'Roundtable reports, judging panel, producer verdicts, and awards presentation.',
      time: '2:45 – 3:45 PM',
      badge: 'FTAC Phase 3',
      type: 'featured',
    },
    {
      icon: 'fa-coffee',
      title: 'Break',
      desc:
        'Short transition before the afternoon fireside chat.',
      time: '3:45 – 4:00 PM',
      type: 'break',
    },
    {
      icon: 'fa-comments',
      title: 'Founder × Farmer Fireside Chat I',
      desc:
        'Beyond the Pitch: Start-up and Farmer\'s details coming soon.',
      time: '4:00 – 4:40 PM',
      badge: 'Fireside chat',
      type: 'featured',
    },
    {
      icon: 'fa-flag-checkered',
      title: 'Day 1 Wrap',
      time: '4:40 – 4:55 PM',
    },
    {
      icon: 'fa-handshake',
      title: 'Networking Reception & Student Poster Session',
      desc:
        'AgConverge Connect partner meetups, student posters, networking, and open exhibits.',
      time: '5:00 – 6:30 PM',
      badge: 'Reception',
      type: 'networking',
    },
  ],

  day2: [
    {
      icon: 'fa-chart-line',
      title: 'Investor–Startup Breakfast',
      desc:
        'Invitation-only breakfast for showcase startups, investors, and corporate venture teams.',
      time: '8:00 – 9:00 AM',
      badge: 'Invitation only',
      type: 'meal',
    },
    {
      icon: 'fa-mug-hot',
      title: 'Coffee & Networking',
      desc:
        'AgConverge Connect partner meetups, open exhibits, and students presenting at their posters.',
      time: '8:15 – 9:00 AM',
      badge: 'Open networking',
      type: 'networking',
    },
    {
      icon: 'fa-microphone',
      title: 'Welcome Back',
      time: '9:00 – 9:05 AM',
    },
    {
      icon: 'fa-comments',
      title: 'Founder × Farmer Fireside Chat II',
      desc:
        'Start-up and Farmer\'s details coming soon.',
      time: '9:05 – 9:40 AM',
      badge: 'Fireside chat',
      type: 'featured',
    },
    {
      icon: 'fa-users',
      title: 'Women in Midwest AgTech',
      desc:
        'Women Shaping the Future of Agricultural Innovation — moderated panel.',
      time: '9:40 – 10:25 AM',
      badge: 'Panel',
      type: 'featured',
    },
    {
      icon: 'fa-robot',
      title: 'Morning Break',
      desc: 'Robotics & Technology Demonstration Arena featured.',
      time: '10:25 – 10:50 AM',
      type: 'break',
    },
    {
      icon: 'fa-leaf',
      title: 'Bio-economy Panel',
      desc:
        'From Commodity to Bioproduct: Building the Regional Bio-economy.',
      time: '10:50 – 11:35 AM',
      badge: 'Panel',
      type: 'featured',
    },
    {
      icon: 'fa-bullhorn',
      title: 'Closing Address',
      desc: 'Ankit Chandra, Spur Ventures.',
      time: '11:35 – 11:50 AM',
    },
    {
      icon: 'fa-flag-checkered',
      title: 'Farewell',
      time: '11:50 AM – 12:00 PM',
    },
    {
      icon: 'fa-utensils',
      title: 'Networking Lunch & Departures',
      desc: 'Continue conversations over lunch before departing.',
      time: '12:00 PM',
      badge: 'Optional',
      type: 'meal',
    },
  ],
};

const tabs = [
  {
    key: 'day1',
    day: 'Day 1',
    date: 'Tuesday, November 17',
  },
  {
    key: 'day2',
    day: 'Day 2',
    date: 'Wednesday, November 18',
  },
];


const heroSlides = [
  {
    image: CarouselImg,
    alt: 'Spur Ventures event',
  },
  {
    image: Carousel1Img,
    alt: 'Spur Ventures conference gathering',
  },
  {
    image: Carousel4Img,
    alt: 'Agricultural innovation event',
  },
  {
    image: Carousel5Img,
    alt: 'AgTech networking event',
  },
  {
    image: Carousel6Img,
    alt: 'Spur Ventures community event',
  },
];


const HarvestHorizonHero = ({
  timeLeft = {
    days: '--',
    hours: '--',
    minutes: '--',
  },
}) => {

  const [activeTab, setActiveTab] =
    useState('day1');

  const [heroSlideIndex, setHeroSlideIndex] =
    useState(0);


  /* =========================================================
     HERO CAROUSEL AUTO ROTATION
     ========================================================= */

  useEffect(() => {

    const heroInterval =
      window.setInterval(() => {

        setHeroSlideIndex((current) =>
          current === heroSlides.length - 1
            ? 0
            : current + 1
        );

      }, 5000);


    return () => {
      window.clearInterval(heroInterval);
    };

  }, []);


  const previousHeroSlide = () => {

    setHeroSlideIndex((current) =>
      current === 0
        ? heroSlides.length - 1
        : current - 1
    );

  };


  const nextHeroSlide = () => {

    setHeroSlideIndex((current) =>
      current === heroSlides.length - 1
        ? 0
        : current + 1
    );

  };


  const activeHeroSlide =
    heroSlides[heroSlideIndex];


  const openRegistration = () => {

    window.open(
      REGISTRATION_URL,
      '_blank',
      'noopener,noreferrer'
    );

  };


  return (
    <>

      {/* =====================================================
          PAGE-SPECIFIC STYLES
          ===================================================== */}

      <style>{`

        /* =====================================================
           NARRATIVE
           ===================================================== */

        .s-narrative {
          width: 100%;
          max-width: 1280px;

          grid-template-columns:
            minmax(390px, 0.85fr)
            minmax(0, 1.15fr);

          gap: 52px;
        }


        .s-pillar-columns {
          width: 100%;
          min-width: 0;

          display: grid;

          grid-template-columns:
            minmax(0, 1.35fr)
            1px
            minmax(230px, 0.85fr);

          gap: 22px;

          align-items: stretch;
        }


        .s-pillar-main-column {
          min-width: 0;

          display: flex;

          flex-direction: column;

          gap: 20px;
        }


        .s-pillar-main-column .s-pillar {
          min-width: 0;
        }


        .s-pillar-divider {
          width: 1px;

          min-height: 100%;

          align-self: stretch;

          background:
            linear-gradient(
              to bottom,
              rgba(45, 80, 22, 0.1),
              rgba(45, 80, 22, 0.32),
              rgba(45, 80, 22, 0.1)
            );
        }


        .s-ftac-resource-column {
          min-width: 0;
        }


        .s-ftac-resource-column > .s-pillar {
          min-width: 0;
        }


        .s-ftac-resource-content {
          width: 100%;

          min-width: 0;
        }


        .s-ftac-resource-content > p {
          margin-bottom: 10px;
        }


        /* =====================================================
           RESOURCE DROPDOWNS
           ===================================================== */

        .s-resource-dropdown {
          position: relative;

          width: 100%;

          margin-top: 10px;

          overflow: hidden;

          border: 1px solid #e1e8da;

          border-left:
            3px solid var(--accent, #2d5016);

          border-radius: 9px;

          background: #ffffff;

          box-shadow:
            0 1px 2px rgba(20, 30, 10, 0.03);

          transition:
            border-color 180ms ease,
            background 180ms ease,
            box-shadow 200ms ease,
            transform 180ms ease;
        }


        .s-resource-dropdown:hover {
          border-color: #b9cbaa;

          box-shadow:
            0 6px 16px rgba(45, 80, 22, 0.08);

          transform: translateY(-1px);
        }


        .s-resource-dropdown[open] {
          border-color: #b6c9a9;

          background: #fbfcf9;

          box-shadow:
            0 8px 20px rgba(45, 80, 22, 0.09);

          transform: translateY(0);
        }


        .s-resource-dropdown--startup {
          --accent: #2d5016;
        }


        .s-resource-dropdown--agenda {
          --accent: #4a7c2f;
        }


        .s-resource-dropdown--student {
          --accent: #e87722;
        }


        .s-resource-dropdown--awards {
          --accent: #c9962c;
        }


        .s-resource-dropdown summary {
          width: 100%;

          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 10px;

          padding: 11px 12px;

          cursor: pointer;

          list-style: none;

          color: #23331a;

          font-size: 11.5px;

          font-weight: 800;

          line-height: 1.35;

          letter-spacing: 0.01em;

          user-select: none;
        }


        .s-resource-dropdown
        summary::-webkit-details-marker {
          display: none;
        }


        .s-resource-summary-left {
          display: flex;

          align-items: center;

          gap: 9px;

          min-width: 0;
        }


        .s-resource-icon {
          flex-shrink: 0;

          display: flex;

          align-items: center;

          justify-content: center;

          width: 24px;

          height: 24px;

          border-radius: 6px;

          background:
            var(--accent, #2d5016);

          color: #ffffff;

          font-size: 10px;
        }


        .s-resource-summary-text {
          display: flex;

          flex-direction: column;

          gap: 2px;

          min-width: 0;
        }


        .s-resource-summary-text .title {
          color: #23331a;
        }


        .s-resource-arrow {
          flex-shrink: 0;

          color: #829078;

          font-size: 8px;

          transition:
            transform 180ms ease;
        }


        .s-resource-dropdown[open]
        .s-resource-arrow {
          transform: rotate(180deg);
        }


        .s-resource-dropdown-body {
          padding:
            0
            12px
            12px
            45px;
        }


        .s-resource-dropdown-body p {
          margin: 0 0 9px;

          color: #64748b;

          font-size: 10px;

          line-height: 1.5;
        }


        .s-resource-link {
          width: fit-content;

          display: inline-flex;

          align-items: center;

          justify-content: center;

          gap: 6px;

          padding: 7px 10px;

          border-radius: 5px;

          background:
            var(--accent, #2d5016);

          color: #ffffff !important;

          font-size: 9px;

          font-weight: 800;

          line-height: 1;

          text-decoration: none;

          transition:
            background 180ms ease,
            transform 180ms ease,
            filter 180ms ease;
        }


        .s-resource-link:hover {
          filter: brightness(1.08);

          color: #ffffff !important;

          transform: translateY(-1px);
        }


        .s-resource-link i {
          font-size: 8px;
        }


        /* =====================================================
           AGCONVERGE HERO CAROUSEL
           ===================================================== */

        .hh-carousel-hero {
          position: relative;

          width: 100%;

          min-height: 0;

          margin: 0;

          padding: 0;

          overflow: hidden;

          background: #ffffff;
        }


        .hh-carousel-slides {
          position: relative;

          width: 100%;

          aspect-ratio: 16 / 9;

          overflow: hidden;

          background: #ffffff;
        }


        .hh-carousel-slide {
          position: absolute;

          inset: 0;

          width: 100%;

          height: 100%;

          opacity: 0;

          visibility: hidden;

          transition:
            opacity 700ms ease,
            visibility 700ms ease;
        }


        .hh-carousel-slide.active {
          opacity: 1;

          visibility: visible;

          z-index: 1;
        }


        .hh-carousel-slide
        .hh-image-hero-img {
          width: 100%;

          height: 100%;

          max-width: none;

          display: block;

          object-fit: cover;

          object-position: center;
        }


        /*
         * Keep the 2026 graphic fully visible.
         */

        .hh-carousel-slide.is-poster
        .hh-image-hero-img {
          object-fit: contain;

          background: #ffffff;
        }


        /*
         * Gradient only on the 2025 photo slides.
         */

        .hh-carousel-photo-overlay {
          position: absolute;

          inset: 0;

          z-index: 2;

          pointer-events: none;

          background:
            linear-gradient(
              to top,
              rgba(12, 30, 8, 0.76) 0%,
              rgba(12, 30, 8, 0.18) 42%,
              rgba(12, 30, 8, 0) 72%
            );
        }


        /* =====================================================
           2025 HIGHLIGHT LABEL
           ===================================================== */

        .hh-carousel-highlight-label {
          position: absolute;

          z-index: 5;

          left: 42px;

          bottom: 118px;

          max-width: 500px;

          display: flex;

          flex-direction: column;

          gap: 5px;

          color: #ffffff;
        }


        .hh-carousel-highlight-label span {
          color: #f58220;

          font-size: 11px;

          font-weight: 900;

          letter-spacing: 0.18em;

          text-transform: uppercase;
        }


        .hh-carousel-highlight-label strong {
          color: #ffffff;

          font-size:
            clamp(20px, 2.5vw, 36px);

          font-weight: 900;

          line-height: 1.12;

          text-shadow:
            0 2px 14px rgba(0, 0, 0, 0.35);
        }


        /* =====================================================
           REGISTER + VIEW PROGRAMME
           ALWAYS ON TOP OF THE CAROUSEL
           ===================================================== */

        .hh-carousel-hero
        .hh-image-hero-actions {
          position: absolute;

          z-index: 7;

          left: 42px;

          bottom: 38px;

          display: flex;

          align-items: center;

          gap: 12px;
        }


        /* =====================================================
           LEFT / RIGHT ARROWS
           ===================================================== */

        .hh-carousel-arrow {
          position: absolute;

          z-index: 8;

          top: 50%;

          width: 44px;

          height: 44px;

          display: flex;

          align-items: center;

          justify-content: center;

          border:
            1px solid rgba(255, 255, 255, 0.72);

          border-radius: 50%;

          background:
            rgba(18, 40, 12, 0.52);

          color: #ffffff;

          cursor: pointer;

          transform:
            translateY(-50%);

          backdrop-filter:
            blur(8px);

          transition:
            background 180ms ease,
            border-color 180ms ease,
            transform 180ms ease;
        }


        .hh-carousel-arrow:hover {
          border-color: #f58220;

          background: #f58220;

          transform:
            translateY(-50%)
            scale(1.04);
        }


        .hh-carousel-arrow-left {
          left: 22px;
        }


        .hh-carousel-arrow-right {
          right: 22px;
        }


        /* =====================================================
           CAROUSEL DOTS
           ===================================================== */

        .hh-carousel-dots {
          position: absolute;

          z-index: 8;

          right: 42px;

          bottom: 48px;

          display: flex;

          align-items: center;

          gap: 8px;
        }


        .hh-carousel-dot {
          width: 9px;

          height: 9px;

          padding: 0;

          border: none;

          border-radius: 50%;

          background:
            rgba(45, 80, 22, 0.62);

          box-shadow:
            0 0 0 1px rgba(255, 255, 255, 0.55);

          cursor: pointer;

          transition:
            width 180ms ease,
            background 180ms ease,
            border-radius 180ms ease;
        }


        .hh-carousel-dot.active {
          width: 28px;

          border-radius: 20px;

          background: #f58220;
        }


        /* =====================================================
           TABLET
           ===================================================== */

        @media (max-width: 1100px) {

          .hh-carousel-highlight-label {
            left: 30px;

            bottom: 110px;
          }


          .hh-carousel-hero
          .hh-image-hero-actions {
            left: 30px;

            bottom: 32px;
          }


          .hh-carousel-dots {
            right: 30px;

            bottom: 43px;
          }


          .s-narrative {
            max-width: 900px;

            grid-template-columns: 1fr;

            gap: 40px;
          }


          .s-pillar-columns {
            grid-template-columns:
              minmax(0, 1.25fr)
              1px
              minmax(220px, 0.75fr);

            gap: 20px;
          }

        }


        /* =====================================================
           MOBILE
           ===================================================== */

        @media (max-width: 720px) {

          .hh-carousel-slides {
            aspect-ratio: 4 / 5;
          }


          .hh-carousel-slide.is-poster
          .hh-image-hero-img {
            object-fit: contain;

            object-position:
              top center;
          }


          .hh-carousel-slide:not(.is-poster)
          .hh-image-hero-img {
            object-fit: cover;
          }


          .hh-carousel-highlight-label {
            left: 20px;

            right: 20px;

            bottom: 145px;
          }


          .hh-carousel-highlight-label strong {
            font-size: 22px;
          }


          .hh-carousel-hero
          .hh-image-hero-actions {
            left: 20px;

            right: 20px;

            bottom: 66px;

            gap: 8px;

            flex-wrap: wrap;
          }


          .hh-carousel-arrow {
            width: 36px;

            height: 36px;
          }


          .hh-carousel-arrow-left {
            left: 10px;
          }


          .hh-carousel-arrow-right {
            right: 10px;
          }


          .hh-carousel-dots {
            left: 20px;

            right: auto;

            bottom: 24px;
          }


          .s-pillar-columns {
            grid-template-columns: 1fr;

            gap: 22px;
          }


          .s-pillar-divider {
            width: 100%;

            height: 1px;

            min-height: 1px;

            background: #d9e2d3;
          }

        }

      `}</style>


      {/* =====================================================
          AGCONVERGE HERO CAROUSEL
          ===================================================== */}

      <section
        className="hh-hero hh-image-hero hh-carousel-hero"
        aria-label="Spur AgConverge highlights"
      >

        {/* SLIDES */}

        <div className="hh-carousel-slides">

          {heroSlides.map((slide, index) => (

            <div
              key={slide.label}
              className={`hh-carousel-slide ${index === heroSlideIndex
                ? 'active'
                : ''
                } ${index === 0
                  ? 'is-poster'
                  : ''
                }`}
              aria-hidden={
                index !== heroSlideIndex
              }
            >

              <img
                src={slide.image}
                alt={slide.alt}
                className="hh-image-hero-img"
                style={{
                  objectPosition:
                    slide.position,
                }}
              />

            </div>

          ))}

        </div>


        {/* 2025 PHOTO OVERLAY */}

        {heroSlideIndex !== 0 && (

          <div className="hh-carousel-photo-overlay" />

        )}


        {/* 2025 HIGHLIGHT TITLE */}

        {heroSlideIndex !== 0 && (

          <div className="hh-carousel-highlight-label">

            <span>
              AgConverge 2025 Highlight
            </span>

            <strong>
              {activeHeroSlide.label}
            </strong>

          </div>

        )}


        {/* REGISTER + PROGRAMME */}

        <div className="hh-image-hero-actions">

          <a
            href={REGISTRATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="hh-image-hero-btn hh-image-hero-btn-primary"
          >
            Register Now

            <i className="fas fa-arrow-right" />
          </a>


          <a
            href="#agenda"
            className="hh-image-hero-btn hh-image-hero-btn-secondary"
          >
            View Programme

            <i className="far fa-calendar-alt" />
          </a>

        </div>


        {/* PREVIOUS */}

        <button
          type="button"
          className="hh-carousel-arrow hh-carousel-arrow-left"
          onClick={previousHeroSlide}
          aria-label="Previous AgConverge highlight"
        >
          <i className="fas fa-chevron-left" />
        </button>


        {/* NEXT */}

        <button
          type="button"
          className="hh-carousel-arrow hh-carousel-arrow-right"
          onClick={nextHeroSlide}
          aria-label="Next AgConverge highlight"
        >
          <i className="fas fa-chevron-right" />
        </button>


        {/* DOTS */}

        <div
          className="hh-carousel-dots"
          aria-label="AgConverge carousel navigation"
        >

          {heroSlides.map((slide, index) => (

            <button
              type="button"
              key={slide.label}
              className={`hh-carousel-dot ${index === heroSlideIndex
                ? 'active'
                : ''
                }`}
              onClick={() =>
                setHeroSlideIndex(index)
              }
              aria-label={`Show ${slide.label}`}
              aria-current={
                index === heroSlideIndex
                  ? 'true'
                  : undefined
              }
            />

          ))}

        </div>

      </section>


      {/* =====================================================
          STATS
          ===================================================== */}

      <div className="s-stats">

        <div className="s-stats-inner">

          <div className="s-stat">

            <span className="n">
              8
            </span>

            <span className="l">
              Global startups
            </span>

          </div>



          <div className="s-stat">

            <span className="n">
              $1000
            </span>

            <span className="l">
              student poster award
            </span>

          </div>

          <div className="s-stat">

            <span className="n">
              2
            </span>

            <span className="l">
              Conference days
            </span>

          </div>


          <div className="s-stat">

            <span className="n">
              $6000
            </span>

            <span className="l">
              In Farm Awards
            </span>

          </div>

        </div>

      </div>


      {/* =====================================================
          COUNTDOWN
          ===================================================== */}

      <div className="s-countdown">

        <div className="s-countdown-inner">

          <span className="s-countdown-label">
            Countdown
          </span>


          <div className="s-countdown-units">

            <div className="s-cu">

              <span className="n">
                {timeLeft.days}
              </span>

              <span className="l">
                Days
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.hours}
              </span>

              <span className="l">
                Hrs
              </span>

            </div>


            <div className="s-cu">

              <span className="n">
                {timeLeft.minutes}
              </span>

              <span className="l">
                Min
              </span>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          NARRATIVE
          ===================================================== */}

      <div className="s-narrative">


        {/* LEFT SIDE */}

        <div className="s-narrative-left">

          <h2>
            Why AgConverge exists
          </h2>


          <p>
            Agriculture does not lack innovation. Every year,
            entrepreneurs launch new technologies, researchers
            generate breakthrough discoveries, and investors deploy
            capital into promising ventures. Yet many innovations
            never make it onto farms and ranches. Some are looking
            for the right customer. Others need additional
            validation. Some solve problems that farmers do not
            actually have. Many simply struggle to move beyond pilot
            projects and early adopters. Spur AgConverge was created
            to help close that gap.
          </p>


          <div className="s-pullquote">

            <p>
              “Adoption happens when farmers help shape innovation
              from the beginning — not after the pitch deck is
              done.”
            </p>

          </div>


          <p>
            AgConverge is focused on strengthening the
            entrepreneurial innovation ecosystem across agriculture,
            animal health, food systems, and climate technologies
            throughout Nebraska and the Midwest. The conference
            serves as a platform where ideas are tested, partnerships
            are formed, and technologies move closer to real-world
            adoption and impact.
          </p>

        </div>


        {/* =================================================
            RIGHT SIDE
            ================================================= */}

        <div className="s-pillar-columns">


          {/* EXISTING FOUR PILLARS */}

          <div className="s-pillar-main-column">


            {/* FARMER-LED VALIDATION */}

            <div className="s-pillar">

              <div className="s-pillar-dot">

                <i className="fas fa-seedling"></i>

              </div>


              <div>

                <h3>
                  Farmer-led validation
                </h3>


                <p>
                  Producers evaluate technologies against real
                  operational challenges — economics, implementation,
                  and fit.
                </p>

              </div>

            </div>


            {/* REAL-WORLD ENVIRONMENTS */}

            <div className="s-pillar">

              <div className="s-pillar-dot">

                <i className="fas fa-flask"></i>

              </div>


              <div>

                <h3>
                  Real-world environments
                </h3>


                <p>
                  Entrepreneurs gain access to on-farm testing through
                  the Spur Validation Sandbox Program.
                </p>

              </div>

            </div>


            {/* RESEARCH PARTNERSHIPS */}

            <div className="s-pillar">

              <div className="s-pillar-dot">

                <i className="fas fa-school"></i>

              </div>


              <div>

                <h3>
                  Research partnerships
                </h3>


                <p>
                  Industry and academia collaborate to reduce technical
                  risk and accelerate commercialization.
                </p>

              </div>

            </div>


            {/* CAPITAL PATHWAYS */}

            <div className="s-pillar">

              <div className="s-pillar-dot">

                <i className="fas fa-coins"></i>

              </div>


              <div>

                <h3>
                  Capital pathways
                </h3>


                <p>
                  Investors gain clearer signals of market demand and
                  adoption potential from farmer verdicts.
                </p>

              </div>

            </div>

          </div>


          {/* VERTICAL SEPARATOR */}

          <div
            className="s-pillar-divider"
            aria-hidden="true"
          />


          {/* =================================================
              REGISTRATION COLUMN
              ================================================= */}

          <div className="s-ftac-resource-column">

            <div className="s-pillar">


              <div className="s-pillar-dot">

                <i className="fas fa-rocket"></i>

              </div>


              <div className="s-ftac-resource-content">

                <h3>
                  Registration
                </h3>


                <p>
                  Startup registration, student registration, agenda,
                  and awards information.
                </p>


                {/* STARTUP REGISTRATION */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--startup
                  "
                >

                  <summary>

                    <span className="s-resource-summary-left">

                      <span className="s-resource-icon">

                        <i className="fas fa-rocket"></i>

                      </span>


                      <span className="s-resource-summary-text">

                        <span className="title">
                          Startup Registration
                        </span>

                      </span>

                    </span>


                    <i className="fas fa-chevron-down s-resource-arrow"></i>

                  </summary>


                  <div className="s-resource-dropdown-body">

                    <p>
                      Register your startup for the Farmer Tech
                      Adoption Challenge at Spur AgConverge 2026.
                    </p>


                    <a
                      href={FTAC_STARTUP_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-resource-link"
                    >
                      Register Startup

                      <i className="fas fa-external-link-alt"></i>

                    </a>

                  </div>

                </details>


                {/* STUDENT REGISTRATION */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--student
                  "
                >

                  <summary>

                    <span className="s-resource-summary-left">

                      <span className="s-resource-icon">

                        <i className="fas fa-user-graduate"></i>

                      </span>


                      <span className="s-resource-summary-text">

                        <span className="title">
                          Student Registration
                        </span>

                      </span>

                    </span>


                    <i className="fas fa-chevron-down s-resource-arrow"></i>

                  </summary>


                  <div className="s-resource-dropdown-body">

                    <p>
                      Students, register to attend and take part in
                      the Student Poster Session at Spur AgConverge
                      2026.
                    </p>


                    <a
                      href={STUDENT_REGISTRATION_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-resource-link"
                    >
                      Register as a Student

                      <i className="fas fa-external-link-alt"></i>

                    </a>

                  </div>

                </details>


                {/* AGENDA */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--agenda
                  "
                >

                  <summary>

                    <span className="s-resource-summary-left">

                      <span className="s-resource-icon">

                        <i className="far fa-calendar-alt"></i>

                      </span>


                      <span className="s-resource-summary-text">

                        <span className="title">
                          AgConverge 2026 Agenda
                        </span>

                      </span>

                    </span>


                    <i className="fas fa-chevron-down s-resource-arrow"></i>

                  </summary>


                  <div className="s-resource-dropdown-body">

                    <p>
                      Download the full November 17–18, 2026
                      conference agenda.
                    </p>


                    <a
                      href={AgConvergeAgendaPDF}
                      download="Spur_AgConverge_2026_Agenda.pdf"
                      className="s-resource-link"
                    >
                      Download Agenda

                      <i className="fas fa-download"></i>

                    </a>

                  </div>

                </details>


                {/* AWARDS */}

                <details
                  className="
                    s-resource-dropdown
                    s-resource-dropdown--awards
                  "
                >

                  <summary>

                    <span className="s-resource-summary-left">

                      <span className="s-resource-icon">

                        <i className="fas fa-trophy"></i>

                      </span>


                      <span className="s-resource-summary-text">

                        <span className="title">
                          Awards
                        </span>

                      </span>

                    </span>


                    <i className="fas fa-chevron-down s-resource-arrow"></i>

                  </summary>


                  <div className="s-resource-dropdown-body">

                    <p>
                      $5,000 in Farm Awards presented to the top
                      farmer roundtables during FTAC Phase 3:
                      Producer Verdict &amp; Farm Awards.
                    </p>


                    <a
                      href={REGISTRATION_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="s-resource-link"
                    >
                      Register Now

                      <i className="fas fa-external-link-alt"></i>

                    </a>

                  </div>

                </details>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          SESSIONS EXPLORER
          ===================================================== */}

      <section
        className="s-sessions"
        id="agenda"
      >

        <div className="s-agenda-hero">


          <div className="s-agenda-heading">

            <span className="s-agenda-kicker">
              Spur AgConverge 2026
            </span>


            <h2>
              Sessions Explorer
            </h2>


            <p>
              Explore two days of keynotes, farmer-led technology
              evaluation, panels, demonstrations, networking, and
              conversations designed to move AgTech toward
              real-world adoption.
            </p>

          </div>


          <div className="s-agenda-meta">


            <div className="s-agenda-meta-item">

              <div className="s-agenda-meta-icon">

                <i className="far fa-calendar"></i>

              </div>


              <div>

                <span>
                  Date
                </span>


                <strong>
                  November 17–18, 2026
                </strong>

              </div>

            </div>


            <div className="s-agenda-meta-item">

              <div className="s-agenda-meta-icon">

                <i className="fas fa-map-marker-alt"></i>

              </div>


              <div>

                <span>
                  Location
                </span>


                <strong>
                  Raising Nebraska
                </strong>


                <small>
                  Grand Island, Nebraska
                </small>

              </div>

            </div>

          </div>

        </div>


        {/* DAY TABS */}

        <div
          className="s-session-tabs"
          role="tablist"
          aria-label="Conference agenda days"
        >

          {tabs.map((tab) => (

            <button
              type="button"
              role="tab"
              id={`${tab.key}-tab`}
              key={tab.key}
              className={`s-stab ${activeTab === tab.key
                ? 'act'
                : ''
                }`}
              onClick={() =>
                setActiveTab(tab.key)
              }
              aria-selected={
                activeTab === tab.key
              }
              aria-controls={`${tab.key}-panel`}
            >

              <span className="s-stab-day">
                {tab.day}
              </span>


              <span className="s-stab-date">
                {tab.date}
              </span>

            </button>

          ))}

        </div>


        {/* SESSION CONTENT */}

        <div
          className="s-session-content"
          id={`${activeTab}-panel`}
          role="tabpanel"
          aria-labelledby={`${activeTab}-tab`}
        >

          <div className="s-agenda-day-header">


            <div>

              <span className="s-agenda-day-label">

                {activeTab === 'day1'
                  ? 'Tuesday'
                  : 'Wednesday'}

              </span>


              <h3>

                {activeTab === 'day1'
                  ? 'November 17, 2026'
                  : 'November 18, 2026'}

              </h3>

            </div>


            <div className="s-agenda-count">

              {sessionData[activeTab].length}
              {' '}
              agenda items

            </div>

          </div>


          <div className="s-scontent act">

            {sessionData[activeTab].map((session) => (

              <article
                className={`s-scard ${session.type
                  ? `is-${session.type}`
                  : ''
                  }`}
                key={`${session.time}-${session.title}`}
              >


                <div className="s-scard-time-column">

                  <span className="s-scard-time">
                    {session.time}
                  </span>

                </div>


                <div className="s-scard-icon">

                  <i
                    className={`fas ${session.icon}`}
                  ></i>

                </div>


                <div className="s-scard-details">

                  <div className="s-scard-heading">

                    <h3>
                      {session.title}
                    </h3>


                    {session.badge && (

                      <span className="s-session-badge">
                        {session.badge}
                      </span>

                    )}

                  </div>


                  {session.desc && (

                    <p>
                      {session.desc}
                    </p>

                  )}

                </div>

              </article>

            ))}

          </div>

        </div>

      </section>


      {/* =====================================================
          HOTEL AND TRAVEL INFORMATION
          ===================================================== */}

      <section
        className="ag-travel-section"
        id="travel"
      >

        <div className="ag-travel-container">


          {/* HEADER */}

          <div className="ag-travel-header">


            <div>

              <span className="ag-travel-eyebrow">
                Plan Your Visit
              </span>


              <h2>
                Hotel &amp; Travel Information
              </h2>

            </div>


            <p>
              Practical information for reaching Raising Nebraska,
              parking at the venue, traveling through Grand Island,
              and choosing nearby accommodations.
            </p>

          </div>


          <div className="ag-travel-layout">


            {/* =================================================
                TRAVEL COLUMN
                ================================================= */}

            <div className="ag-travel-column">

              <div className="ag-travel-column-heading">


                <span>
                  01
                </span>


                <div>

                  <small>
                    Getting here
                  </small>


                  <h3>
                    Travel to Grand Island
                  </h3>

                </div>

              </div>


              <div className="ag-travel-card-list">


                {/* VENUE */}

                <article className="ag-travel-card">

                  <div className="ag-travel-icon">

                    <i className="fas fa-map-marker-alt" />

                  </div>


                  <div>

                    <span className="ag-travel-label">
                      Conference venue
                    </span>


                    <h4>
                      Raising Nebraska
                    </h4>


                    <p>
                      Nebraska Building at Fonner Park
                      <br />
                      501 E. Fonner Park Road, Suite 100
                      <br />
                      Grand Island, Nebraska 68801
                    </p>


                    <a
                      href="https://www.google.com/maps/search/?api=1&query=Raising+Nebraska+501+E+Fonner+Park+Road+Grand+Island+NE+68801"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Open directions

                      <i className="fas fa-external-link-alt" />

                    </a>

                  </div>

                </article>


                {/* PARKING */}

                <article className="ag-travel-card">

                  <div className="ag-travel-icon">

                    <i className="fas fa-car" />

                  </div>


                  <div>

                    <span className="ag-travel-label">
                      Parking
                    </span>


                    <h4>
                      Free Parking at the Nebraska Building
                    </h4>


                    <p>
                      Free accessible parking is available on the
                      west side of the Nebraska Building. Buses and
                      motorcoaches are encouraged to use the east
                      lot.
                    </p>


                    <a
                      href="https://raisingnebraska.net/visitor-information/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Venue visitor information

                      <i className="fas fa-external-link-alt" />

                    </a>

                  </div>

                </article>


                {/* AIRPORT */}

                <article className="ag-travel-card">

                  <div className="ag-travel-icon">

                    <i className="fas fa-plane" />

                  </div>


                  <div>

                    <span className="ag-travel-label">
                      Traveling by air
                    </span>


                    <h4>
                      Central Nebraska Regional Airport
                    </h4>


                    <p>
                      Grand Island&apos;s airport offers nonstop
                      service to Dallas–Fort Worth, Las Vegas, and
                      Phoenix–Mesa. Confirm current schedules
                      directly with the airport and airline before
                      booking.
                    </p>


                    <a
                      href="https://flygrandisland.com/book-now/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View flight information

                      <i className="fas fa-external-link-alt" />

                    </a>

                  </div>

                </article>


                {/* LOCAL TRANSPORTATION */}

                <article className="ag-travel-card">

                  <div className="ag-travel-icon">

                    <i className="fas fa-route" />

                  </div>


                  <div>

                    <span className="ag-travel-label">
                      Local transportation
                    </span>


                    <h4>
                      Rental Cars, Transit, and Rail
                    </h4>


                    <p>
                      Hertz, Thrifty, and Dollar operate on-site
                      rental-car service at the airport. Grand Island
                      Tourism also lists CRANE public transit, taxi
                      service, and Amtrak service through Hastings.
                    </p>


                    <a
                      href="https://visitgrandisland.com/plan-a-trip/transportation.html"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Explore transportation options

                      <i className="fas fa-external-link-alt" />

                    </a>

                  </div>

                </article>

              </div>

            </div>


            {/* =================================================
                HOTEL COLUMN
                ================================================= */}

            <div className="ag-hotel-column">

              <div className="ag-travel-column-heading">


                <span>
                  02
                </span>


                <div>

                  <small>
                    Where to stay
                  </small>


                  <h3>
                    Hotel Options
                  </h3>

                </div>

              </div>


              <div className="ag-hotel-list">

                {hotelOptions.map((hotel) => (

                  <a
                    href={hotel.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="ag-hotel-card"
                    key={hotel.name}
                  >

                    <div className="ag-hotel-card-top">

                      <span className="ag-hotel-tag">
                        {hotel.label}
                      </span>


                      <span
                        className="ag-hotel-arrow"
                        aria-hidden="true"
                      >

                        <i className="fas fa-external-link-alt" />

                      </span>

                    </div>


                    <h4>
                      {hotel.name}
                    </h4>


                    <p className="ag-hotel-address">

                      <i className="fas fa-map-marker-alt" />


                      <span>
                        {hotel.address}
                      </span>

                    </p>


                    <p className="ag-hotel-phone">

                      <i className="fas fa-phone" />


                      <span>
                        {hotel.phone}
                      </span>

                    </p>


                    <p className="ag-hotel-description">
                      {hotel.description}
                    </p>


                    <span className="ag-hotel-link">

                      Check availability

                      <i className="fas fa-arrow-right" />

                    </span>

                  </a>

                ))}

              </div>


              <div className="ag-hotel-note">

                <i className="fas fa-info-circle" />


                <div>

                  <strong>
                    Booking note
                  </strong>


                  <p>
                    Rates and availability change frequently. Unless
                    a Spur room block is announced separately,
                    reserve directly with the hotel and confirm
                    cancellation terms before booking.
                  </p>

                </div>

              </div>


              <a
                href="https://www.visitgrandisland.com/where-to-stay"
                target="_blank"
                rel="noopener noreferrer"
                className="ag-all-hotels-link"
              >
                Browse more Grand Island lodging

                <i className="fas fa-arrow-right" />

              </a>

            </div>

          </div>

        </div>

      </section>


      {/* =====================================================
          FTAC
          ===================================================== */}

      <div className="s-ftac">

        <div className="s-ftac-inner">

          <h2>
            The Farmers Tech Adoption Challenge™
          </h2>


          <p className="sub">
            A first-of-its-kind farmer-led market validation
            platform — the only event in agriculture where producers
            evaluate technologies live, on stage, in front of
            investors and industry.
          </p>


          <div className="s-ftac-track">


            {/* PHASE 1 */}

            <div className="s-fbox">

              <div className="s-fbox-phase">
                Phase 01
              </div>


              <div className="s-fbox-num">
                01
              </div>


              <h3>
                Startup Showcase
              </h3>


              <p>
                8 selected startups · 8 minutes each · live Q&amp;A
                · technologies from across the U.S. and the world
              </p>

            </div>


            <div className="s-farrow">

              <i className="fas fa-arrow-right"></i>

            </div>


            {/* PHASE 2 */}

            <div className="s-fbox center">

              <div className="s-fbox-phase">
                Phase 02
              </div>


              <div className="s-fbox-num">
                02
              </div>


              <h3>
                Farmer Roundtables
              </h3>


              <p>
                Producers evaluate each technology on economics,
                ease of implementation, scalability, and adoption
                likelihood
              </p>

            </div>


            <div className="s-farrow">

              <i className="fas fa-arrow-right"></i>

            </div>


            {/* PHASE 3 */}

            <div className="s-fbox">

              <div className="s-fbox-phase">
                Phase 03
              </div>


              <div className="s-fbox-num">
                03
              </div>


              <h3>
                Producer Verdict
              </h3>


              <p>
                Roundtables report findings · independent judges
                score · Farm Awards presented · commercialization
                pathways identified
              </p>

            </div>

          </div>


          <div className="s-ftac-cta">

            <button
              type="button"
              className="btn-og3"
              onClick={openRegistration}
            >
              Register for FTAC™
            </button>

          </div>

        </div>

      </div>


      {/* =====================================================
          VENUE
          ===================================================== */}

      <div className="s-venue">

        <div className="s-venue-inner">


          <div className="s-v">

            <div className="s-v-label">
              Venue
            </div>


            <div className="s-v-val">
              Raising Nebraska
            </div>


            <div className="s-v-sub">
              Grand Island, Nebraska 68801
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Date
            </div>


            <div className="s-v-val">
              November 17, 2026
            </div>


            <div className="s-v-sub">
              8:00 AM – 6:30 PM
            </div>


            <div className="s-v-val">
              November 18, 2026
            </div>


            <div className="s-v-sub">
              8:00 AM – 12:00 PM
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Hosted by
            </div>


            <div className="s-v-val">
              Spur Ventures at UNL
            </div>


            <div className="s-v-sub">
              University of Nebraska–Lincoln
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Parking
            </div>


            <div className="s-v-val">
              Free on-site
            </div>


            <div className="s-v-sub">
              ADA accessible · WiFi included
            </div>

          </div>


          <div className="s-v">

            <div className="s-v-label">
              Catering
            </div>


            <div className="s-v-val">
              Breakfast &amp; lunch
            </div>


            <div className="s-v-sub">
              Included with registration
            </div>

          </div>

        </div>

      </div>


      {/* =====================================================
          CLOSING CTA
          ===================================================== */}

      <div className="s-cta">

        <h2>
          Join AgConverge '26
        </h2>


        <p>
          The result is more than a conference — a platform for
          validation, adoption, ecosystem building, and investment
          in the Midwest&apos;s agricultural future.
        </p>


        <div className="s-cta-chips">

          <span className="s-chip">
            <i className="fas fa-check"></i>
            Lunch included
          </span>


          <span className="s-chip">
            <i className="fas fa-check"></i>
            Live FTAC™
          </span>


          <span className="s-chip">
            <i className="fas fa-check"></i>
            Robotics arena
          </span>


          <span className="s-chip">
            <i className="fas fa-check"></i>
            Women in Ag Forum
          </span>


          <span className="s-chip">
            <i className="fas fa-check"></i>
            Farm Awards
          </span>

        </div>


        <button
          type="button"
          className="btn-og3"
          style={{
            fontSize: '15px',
            padding: '14px 36px',
          }}
          onClick={openRegistration}
        >
          Register Now
        </button>

      </div>

    </>
  );
};


export default HarvestHorizonHero;